<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import AlertForm from './AlertForm.vue'

export default {
  components: { AlertForm },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    context: { type: String, required: true },
    contextId: { type: [String, Number], required: true },
    show: { type: Boolean, default: true },
    object: { type: Object },
  },

  data() {
    return {
      alerts: [],
      params: {},
      open: false,
      alert: {},
    }
  },

  methods: {
    showModal(id) {
      this.open = true
      this.$refs['alertform' + id][0].showForm()
    },
    changeOpen() {
      this.open = false
    },
    setValueAlertList: function (data, propertyOrIndex, valuesToSet) {
      data[propertyOrIndex] = valuesToSet
    },
    reloadData(alert) {
      for (const [index, alt] of Object.entries(this.alerts)) {
        if (alt.id == alert.id) {
          this.setValueAlertList(this.alerts, index, alert)
        }
      }
      this.loadAlert()
    },
    reloadPage() {
      window.location.reload()
    },
    loadAlert() {
      this.getJSON('alerts?context=' + this.context + '&contextId=' + this.contextId).then((json) => {
        this.alerts = json
        this.params = { context: this.context, contextId: this.contextId }
        this.$emit('alert-info', json)
      })
    },
  },

  beforeMount() {
    this.loadAlert()
  },
}
</script>
<template>
  <div :class="'subtitle row' + (show ? '' : ' d-none')" role="alert">
    <div
      v-for="alert in alerts"
      v-if="!alert.doneAt"
      :class="
        'py-2 alert-model alert-' +
        (alert.archivedAt ? 'secondary' : alert.type && alert.type.blocking ? 'danger' : 'warning')
      "
    >
      <div class="d-flex">
        <div class="col-md-4 fs-20 font-weight-bold" v-html="alert.subject"></div>
        <div class="col-md-6 pl-3"></div>
        <div class="col-md-2 d-flex justify-content-end align-items-center" style="cursor: pointer">
          <i
            v-if="alert?.type?.isArchivable"
            :class="!open ? 'fas fa-edit' : 'fas fa-circle-notch'"
            @click="showModal(alert.id)"
            e2e-button="showAlert"
          />
          <AlertForm
            :ref="'alertform' + alert.id"
            :params="params"
            :alert-id="alert.id"
            :object="object"
            @open-modal="changeOpen"
            @alert-sent="reloadData"
            @validate-sent="reloadPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
